import TextToolTip from "@lhd/components/TextToolTip";
import { getPrimaryCompanyNameDisplayText } from "@lhd/features/Apps/utils";

const PrimaryCompanyName = () => {
  return (
    <div
      style={{
        height: "100%",
        maxHeight: "42px",
        overflow: "hidden",
        padding: "0px 10px ",
      }}
      className="d-flex flex-center"
    >
      <TextToolTip>{getPrimaryCompanyNameDisplayText()}</TextToolTip>
    </div>
  );
};

export default PrimaryCompanyName;
